import { deleteFile, downloadFile, uploadFile } from "./actions";

export const files = { 
    "label": "Uploaded Files and Documents",
    "key": "Files",
    "local": true,
    "headers": [{
        "headerName": "File",
        "field": "File"
    }],
    "actions": [{
        "label": "Upload File",
        "action": uploadFile
    }],
    "rowActions": [{
        "label": "Download File",
        "action": downloadFile
    }, {
        "label": "Delete File",
        "action": deleteFile
    }]
};
